import { useEffect, useState } from 'react';
import { CountryCode } from '../../urls-config';

export interface AuthenticationState {
  authenticated: boolean;
  registerUrl: string;
  signInUrl: string;
  signOutUrl: string;
}

export interface TrimContext {
  authenticationState: AuthenticationState;
  currentLocale: string;
  domainCountryCode: CountryCode;
  firstName: string;
  footerLinks: Record<string, string>;
  isDisputeEnabled: boolean;
  supportedLanguages: string[];
  textDirection: string;
  weblabContextMap: Record<string, string>;
}

export interface TrimContextResponse {
  context?: TrimContext;
  error: any;
  isError: boolean;
}

const GET_TRIM_V2_URL = '/report/infringement/api/v2/trim';

export function useTrimContext(): TrimContextResponse {
  const [data, setData] = useState<TrimContext | undefined>();
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const fetchTrimContext = async () => {
      try {
        const response = await fetch(GET_TRIM_V2_URL, {
          body: JSON.stringify({
            hostname: window.location.hostname,
            queryParams: window.location.search,
            requestPath: window.location.pathname,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
        });

        if (!response.ok) {
          throw new Error('An error occurred while fetching trim context data');
        }

        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err);
      }
    };

    fetchTrimContext();
  }, []);

  return {
    context: data,
    error,
    isError: !!error,
  };
}
